import { CustomerRunTotal, RPMAcctRunTotal, TicketRunTotal, RunTotalResponse } from '../../store/RunTotal';
import { WorkflowEvent } from '../../store/WorkflowEvent';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getCustomerRunTotals = (customerId: string) => {
  return apiService.callExternalApi<RunTotalResponse<CustomerRunTotal>>({
    url: `${API_SERVER_URL}/customer-run-totals/customer/${customerId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getCustomerSupplierRunTotals = (customerId: string, supplierId: string) => {
  return apiService.callExternalApi<RunTotalResponse<CustomerRunTotal>>({
    url: `${API_SERVER_URL}/customer-supplier-run-totals/customer/${customerId}/supplier/${supplierId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getTicketRunTotals = (ticketId: string) => {
  return apiService.callExternalApi<RunTotalResponse<TicketRunTotal>>({
    url: `${API_SERVER_URL}/ticket-run-totals/ticket/${ticketId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getRPMAcctRunTotals = (rpmAcctId: string) => {
  return apiService.callExternalApi<RunTotalResponse<RPMAcctRunTotal>>({
    url: `${API_SERVER_URL}/rpm-account-run-totals/rpm-account/${rpmAcctId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getCurrentWorkflow = () => {
  return apiService.callExternalApi<WorkflowEvent>({
    url: `${API_SERVER_URL}/base-run-totals/workflow/current`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const startRunTotalsApi = () => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/base-run-totals/run`,
    method: 'POST',
    headers: { 'content-type': 'application/json' }
  });
};
